import React from "react"
import {
  Box,
  Button,
  Checkbox,
  Column,
  Columns,
  Control,
  Field,
  Input,
  TextArea,
  Title,
} from "@allxsmith/bestax-bulma";

export const OnHireSection = ({rental, onChange}) => {

  return (
    <Box>
      <Title>On Hire</Title>
      <Columns isMultiline>
          <Column>
              <Field className="has-addons">
                <Control>
                  <label className="label">Our Insurance</label>
                  <Button
                    color={rental.on_hire_insurance_completed === "NOT_REQUIRED"  ? "primary" : ""}
                    onClick={() => onChange({target: {name: "on_hire_insurance_completed", value: "NOT_REQUIRED"}})}
                  >
                    Not Required
                  </Button>
                  <Button
                    color={rental.on_hire_insurance_completed === "NOT_DONE"  ? "danger" : ""}
                    onClick={() => onChange({target: {name: "on_hire_insurance_completed", value: "NOT_DONE"}})}
                  >
                    Not Done
                  </Button>
                  <Button
                    color={rental.on_hire_insurance_completed === "COMPLETE" ? "success" : ""}
                    onClick={() => onChange({target: {name: "on_hire_insurance_completed", value: "COMPLETE"}})}
                  >
                    Complete
                  </Button>
                </Control>
              </Field>
          </Column>
          <Column>
              <Field className="has-addons">
                <Control>
                  <label className="label">Tracker Access</label>
                  <Button
                    color={rental.on_hire_tracker_completed === "NOT_REQUIRED"  ? "primary" : ""}
                    onClick={() => onChange({target: {name: "on_hire_tracker_completed", value: "NOT_REQUIRED"}})}
                  >
                    Not Required
                  </Button>
                  <Button
                    color={rental.on_hire_tracker_completed === "NOT_DONE"  ? "danger" : ""}
                    onClick={() => onChange({target: {name: "on_hire_tracker_completed", value: "NOT_DONE"}})}
                  >
                    Not Done
                  </Button>
                  <Button
                    color={rental.on_hire_tracker_completed === "COMPLETE" ? "success" : ""}
                    onClick={() => onChange({target: {name: "on_hire_tracker_completed", value: "COMPLETE"}})}
                  >
                    Complete
                  </Button>
                </Control>
              </Field>
          </Column>
          <Column>
              <Field className="has-addons">
                <Control>
                  <label className="label">Key Unassigned</label>
                  <Button
                    color={rental.key_unassigned  ? "" : "danger"}
                    onClick={() => onChange({target: {name: "key_unassigned", value: false}})}
                  >
                    Assigned
                  </Button>
                  <Button
                    color={rental.key_unassigned ? "success" : ""}
                    onClick={() => onChange({target: {name: "key_unassigned", value: true}})}
                  >
                    Unassigned
                  </Button>
                </Control>
              </Field>
          </Column>
        </Columns>
      <Columns isMultiline>
          <Column>
              <label className="label">Order Number</label>
              <Input
                  type={"text"}
                  name={"order_number"}
                  onChange={onChange}
                  value={rental.order_number}
              />
          </Column>
          <Column>
              <label className="label">Vehicle Collected / Delivered</label>
              <Checkbox
                  name={"vehicle_collected"}
                  checked={rental.vehicle_collected}
                  onChange={() => onChange({target: {name: "vehicle_collected", value:!rental.vehicle.collected}})}
              />
          </Column>
          <Column>
              <label className="label">On Hire Time</label>
              <Input
                  type={"time"}
                  value={rental.on_hire_time}
                  onChange={onChange}
                  name={"on_hire_time"}
              />
          </Column>
      </Columns>
      <Columns isMultiline>
          <Column>
              <label className="label">Internal Comments (Will not appear on contract)</label>
              <TextArea
                  name={"comments"}
                  onChange={onChange}
                  value={rental.comments}
              />
          </Column>
          <Column>
              <label className="label">Contract Comments</label>
              <TextArea
                  name={"contract_comments"}
                  onChange={onChange}
                  value={rental.contract_comments}
              />
          </Column>
      </Columns>
    </Box>
  );
}